import { Box, Container, Grid, Paper, Typography } from "@mui/material";

const BROKERS = [
  { name: "Dhan", tagline: "API-based broker integration" },
  { name: "Zerodha", sub: "Kite Connect", tagline: "OAuth-based broker integration" },
  { name: "ICICI Direct", sub: "Breeze API", tagline: "Session-based broker integration" },
];

export function BrokerIntegrationsSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 12 }, bgcolor: "grey.50" }} id="broker-integrations">
      <Container maxWidth="lg">
        <Typography variant="h4" fontWeight={800} textAlign="center" mb={7}>
          Trusted Broker Integrations
        </Typography>

        <Grid container spacing={3} justifyContent="center" mb={5}>
          {BROKERS.map((broker) => (
            <Grid item xs={12} sm={4} key={broker.name}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  p: 4,
                  textAlign: "center",
                  height: "100%",
                  transition: "box-shadow .2s, transform .2s",
                  "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
                }}
              >
                <Typography variant="h5" fontWeight={800}>
                  {broker.name}
                  {broker.sub && (
                    <Typography component="span" variant="h5" fontWeight={800} color="primary.main">
                      {" "}
                      {broker.sub}
                    </Typography>
                  )}
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>
                  {broker.tagline}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Typography variant="body1" color="text.secondary" textAlign="center">
          Connect your existing broker account securely. TekStar Invest never stores your trading
          password.
        </Typography>
      </Container>
    </Box>
  );
}

export default BrokerIntegrationsSection;
